var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirCurve2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 53L55 17C55 12.5817 51.4183 9 47 9L9 9",
    stroke: "#5AB453",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2678 0.732233C10.2915 -0.244078 8.70854 -0.244078 7.73223 0.732233L1.52157 6.9429C0.349998 8.11447 0.349998 10.014 1.52157 11.1855L7.73223 17.3962C8.70854 18.3725 10.2915 18.3725 11.2678 17.3962C12.2441 16.4199 12.2441 14.837 11.2678 13.8607L6.47132 9.06422L11.2678 4.26777C12.2441 3.29146 12.2441 1.70854 11.2678 0.732233Z",
    fill: "#5AB453"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 56.5C56.933 56.5 58.5 54.933 58.5 53C58.5 51.067 56.933 49.5 55 49.5C53.067 49.5 51.5 51.067 51.5 53C51.5 54.933 53.067 56.5 55 56.5Z",
    stroke: "#5AB453",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirCurve2);
export default __webpack_public_path__ + "static/media/dir-curve2.30787593.svg";
export { ForwardRef as ReactComponent };